export const DATA_STATUS_MINIMUM_DATE = '2024-07-01';
